var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiodataIc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 14.6663C4.31792 14.6663 1.33325 11.6817 1.33325 7.99967C1.33325 4.31767 4.31792 1.33301 7.99992 1.33301C11.6819 1.33301 14.6666 4.31767 14.6666 7.99967C14.6666 11.6817 11.6819 14.6663 7.99992 14.6663ZM7.99992 13.333C9.41441 13.333 10.771 12.7711 11.7712 11.7709C12.7713 10.7707 13.3333 9.41416 13.3333 7.99967C13.3333 6.58519 12.7713 5.22863 11.7712 4.22844C10.771 3.22824 9.41441 2.66634 7.99992 2.66634C6.58543 2.66634 5.22888 3.22824 4.22868 4.22844C3.22849 5.22863 2.66659 6.58519 2.66659 7.99967C2.66659 9.41416 3.22849 10.7707 4.22868 11.7709C5.22888 12.7711 6.58543 13.333 7.99992 13.333ZM4.66658 7.99967H5.99992C5.99992 8.53011 6.21063 9.03882 6.5857 9.41389C6.96078 9.78896 7.46949 9.99967 7.99992 9.99967C8.53035 9.99967 9.03906 9.78896 9.41413 9.41389C9.7892 9.03882 9.99992 8.53011 9.99992 7.99967H11.3333C11.3333 8.88373 10.9821 9.73158 10.3569 10.3567C9.73182 10.9818 8.88397 11.333 7.99992 11.333C7.11586 11.333 6.26802 10.9818 5.6429 10.3567C5.01777 9.73158 4.66658 8.88373 4.66658 7.99967Z",
    fill: "#85858E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiodataIc);
export default __webpack_public_path__ + "static/media/biodata-ic.9018fb3eca8999b7f9ba0aea0815bac9.svg";
export { ForwardRef as ReactComponent };